export const STATE_NAME = 'ppsi';

export const FETCH_PPSI = 'PPSI_FETCH_PPSI';
export const FETCH_PPSI_DONE = 'PPSI_FETCH_PPSI_DONE';
export const FETCH_PPSI_FAIL = 'PPSI_FETCH_PPSI_FAIL';

export const DELETE_PPSI = 'PPSI_DELETE_PPSI';
export const DELETE_PPSI_DONE = 'PPSI_DELETE_DONE';
export const DELETE_PPSI_FAIL = 'PPSI_DELETE_PPSI_FAIL';

export const CREATE_PPSI_VARIANT = 'CREATE_PPSI_VARIANT';
export const CREATE_PPSI_VARIANT_DONE = 'CREATE_PPSI_VARIANT_DONE';
export const CREATE_PPSI_VARIANT_FAIL = 'CREATE_PPSI_VARIANT_FAIL';

export const FETCH_PPSIS = 'PPSI_FETCH_PPSIS';
export const FETCH_PPSIS_DONE = 'PPSI_FETCH_PPSIS_DONE';
export const FETCH_PPSI_GLOBAL = 'PPSI_FETCH_PPSI_GLOBAL';
export const FETCH_PPSI_GLOBAL_COPY = 'PPSI_FETCH_PPSI_GLOBAL_COPY';
export const FETCH_PPSIS_GLOBAL = 'PPSI_FETCH_PPSIS_GLOBAL';
export const FETCH_PPSIS_NEW_GLOBAL = 'PPSI_FETCH_NEW_PPSIS_GLOBAL';
export const FETCH_PPSIS_GLOBAL_PUBLISHED = 'PPSI_FETCH_PPSIS_GLOBAL_PUBLISHED';

export const FETCH_PPSIS_FAIL = 'PPSI_FETCH_PPSIS_FAIL';
export const FETCH_GLOBAL_STATUS_PPSIS = 'PPSI_FETCH_GLOBAL_STATUS_PPSI';
export const FETCH_GLOBAL_STATUS_PPSIS_DONE =
  'PPSI_FETCH_GLOBAL_STATUS_PPSI_DONE';
export const FETCH_GLOBAL_STATUS_PPSIS_FAIL =
  'PPSI_FETCH_GLOBAL_STATUS_PPSI_FAIL';
export const CREATE_PPSI = 'PPSI_CREATE_PPSI';
export const CREATE_PPSI_DONE = 'PPSI_CREATE_PPSI_DONE';
export const CREATE_PPSI_FAIL = 'PPSI_CREATE_PPSI_FAIL';
export const SAVE_PPSI = 'PPSI_SAVE_PPSI';
export const SAVE_PPSI_DONE = 'PPSI_SAVE_PPSI_DONE';
export const SAVE_PPSI_FAIL = 'PPSI_SAVE_PPSI_FAIL';
export const APPROVE_PPSI = 'PPSI_APPROVE_PPSI';
export const APPROVE_PPSI_DONE = 'PPSI_APPROVE_PPSI_DONE';
export const APPROVE_PPSI_FAIL = 'PPSI_APPROVE_PPSI_FAIL';
export const PUBLISH_PPSI = 'PPSI_PUBLISH_PPSI';
export const PUBLISH_PPSI_DONE = 'PPSI_PUBLISH_PPSI_DONE';
export const PUBLISH_PPSI_FAIL = 'PPSI_PUBLISH_PPSI_FAIL';
export const PUBLISH_EMPTY_PPSI = 'PUBLISH_EMPTY_PPSI';
export const PUBLISH_EMPTY_PPSI_DONE = 'PUBLISH_EMPTY_PPSI_DONE';
export const PUBLISH_EMPTY_PPSI_FAIL = 'PUBLISH_EMPTY_PPSI_FAIL';
export const UNPUBLISH_PPSI = 'PPSI_UNPUBLISH_PPSI';
export const UNPUBLISH_PPSI_DONE = 'PPSI_UNPUBLISH_PPSI_DONE';
export const UNPUBLISH_PPSI_FAIL = 'PPSI_UNPUBLISH_PPSI_FAIL';
export const MARK_AS_UPTODATE_PPSI = 'PPSI_MARK_AS_UPTODATE_PPSI';
export const MARK_AS_UPTODATE_PPSI_DONE = 'PPSI_MARK_AS_UPTODATE_PPSI_DONE';
export const MARK_AS_UPTODATE_PPSI_FAIL = 'PPSI_MARK_AS_UPTODATE_PPSI_FAIL';
export const CREATE_DRAFT_PPSI = 'PPSI_CREATE_DRAFT';
export const CREATE_DRAFT_PPSI_DONE = 'PPSI_CREATE_DRAFT_DONE';
export const CREATE_DRAFT_PPSI_FAIL = 'PPSI_CREATE_DRAFT_FAIL';
export const IMPORT_IFOOD_UPDATE_PPSI = 'IMPORT_IFOOD_UPDATE_PPSI';
export const IMPORT_IFOOD_UPDATE_PPSI_DONE = 'IMPORT_IFOOD_UPDATE_PPSI_DONE';
export const IMPORT_IFOOD_UPDATE_PPSI_FAIL = 'IMPORT_IFOOD_UPDATE_PPSI_FAIL';
export const IMPORT_GLOBAL_UPDATE_PPSI = 'IMPORT_GLOBAL_UPDATE_PPSI';
export const IMPORT_GLOBAL_UPDATE_PPSI_DONE = 'IMPORT_GLOBAL_UPDATE_PPSI_DONE';
export const IMPORT_GLOBAL_UPDATE_PPSI_FAIL = 'IMPORT_GLOBAL_UPDATE_PPSI_FAIL';
export const DISCARD_DRAFT_PPSI = 'PPSI_DISCARD_DRAFT_PPSI';
export const DISCARD_DRAFT_PPSI_DONE = 'PPSI_DISCARD_DRAFT_PPSI_DONE';
export const DISCARD_DRAFT_PPSI_FAIL = 'PPSI_DISCARD_DRAFT_PPSI_FAIL';
export const FETCH_REVIEW_PPSIS = 'PPSI_FETCH_REVIEW_PPSIS';
export const FETCH_REVIEW_PPSIS_DONE = 'PPSI_FETCH_REVIEW_PPSIS_DONE';
export const FETCH_REVIEW_PPSIS_FAIL = 'PPSI_FETCH_REVIEW_PPSIS_FAIL';
export const FETCH_PPSIS_REVIEW_SUMMARY = 'FETCH_PPSIS_REVIEW_SUMMARY';
export const SUBMIT_FOR_REVIEW_PPSI = 'PPSI_SUBMIT_FOR_REVIEW_PPSI';
export const SUBMIT_FOR_REVIEW_PPSI_DONE = 'PPSI_SUBMIT_FOR_REVIEW_PPSI_DONE';
export const SUBMIT_FOR_REVIEW_PPSI_FAIL = 'PPSI_SUBMIT_FOR_REVIEW_PPSI_FAIL';
export const GLOBAL_APPROVE_REVIEW_PPSI = 'PPSI_GLOBAL_APPROVE_REVIEW_PPSI';
export const GLOBAL_APPROVE_REVIEW_PPSI_DONE =
  'PPSI_GLOBAL_APPROVE_REVIEW_PPSI_DONE';
export const GLOBAL_APPROVE_REVIEW_PPSI_FAIL =
  'PPSI_GLOBAL_APPROVE_REVIEW_PPSI_FAIL';
export const GLOBAL_REJECT_REVIEW_PPSI = 'PPSI_GLOBAL_REJECT_REVIEW_PPSI';
export const GLOBAL_REJECT_REVIEW_PPSI_DONE =
  'PPSI_GLOBAL_REJECT_REVIEW_PPSI_DONE';
export const GLOBAL_REJECT_REVIEW_PPSI_FAIL =
  'PPSI_GLOBAL_REJECT_REVIEW_PPSI_FAIL';

export const FETCH_PPSIS_REVIEW_SUMMARY_DONE =
  'FETCH_PPSIS_REVIEW_SUMMARY_DONE';
export const FETCH_PPSIS_REVIEW_SUMMARY_FAIL =
  'FETCH_PPSIS_REVIEW_SUMMARY_FAIL';
export const FETCH_GLOBAL_APPROVAL_PPSI = 'FETCH_GLOBAL_APPROVAL_PPSI';
export const FETCH_GLOBAL_APPROVAL_PPSI_DONE =
  'FETCH_GLOBAL_APPROVAL_PPSI_DONE';
export const FETCH_GLOBAL_APPROVAL_PPSI_FAIL =
  'FETCH_GLOBAL_APPROVAL_PPSI_FAIL';

export const FETCH_TOTAL_RANGE_REPORT = 'PPSI_TOTAL_RANGE_REPORT';
export const FETCH_TOTAL_RANGE_REPORT_DONE = 'PPSI_TOTAL_RANGE_REPORT_DONE';
export const FETCH_TOTAL_RANGE_REPORT_FAIL = 'PPSI_TOTAL_RANGE_REPORT_FAIL';

export const States = {
  DRAFT: 'DRAFT',
  REVIEW: 'REVIEW',
  REJECTED: 'REJECTED',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  GLOBALREVIEW: 'GLOBAL REVIEW',
  GLOBALREJECTED: 'GLOBAL REJECTED',
  GLOBALAPPROVED: 'GLOBAL APPROVED',
  UPDATES: 'UPDATED'
};

export const EnrichmentData = {
  IN_PROGRESS: 'inProgressPpsiEnrichmentData',
  PUBLISHED: 'publishedPpsiEnrichmentData'
};

export const SERVING_HOLDING_TEMP_UNIT_DEFAULT = '100';
export const SERVING_HOLDING_TIME_UNIT_DEFAULT = '101';

export const MainImageThumbnail = {
  Height: 500,
  Width: 500
};

export const PlateItRightImageThumbnail = {
  Height: 220,
  Width: 220
};
export const LabelImageThumbnail = {
  Height: 200,
  Width: 200
};
// CO_WORKER_ENGAGEMENT_REPORT
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT';
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT_DONE =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT_DONE';
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT_FAIL =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT_FAIL';

// CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST';
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_DONE =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_DONE';
export const FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_FAIL =
  'FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_FAIL';

// Consts for uploading BOM Report for NIR Markets
export const UPLOAD_BOM_REPORT = 'UPLOAD_BOM_REPORT';
export const UPLOAD_BOM_REPORT_SUCCESS = 'UPLOAD_BOM_REPORT_SUCCESS';
export const UPLOAD_BOM_REPORT_FAILURE = 'UPLOAD_BOM_REPORT_FAILURE';
export const UPLOAD_BOM_REPORT_RESET = 'UPLOAD_BOM_REPORT_RESET';

// Fetch global non-specific  PPSIS. Currently only for NIR markets
export const FETCH_GLOBAL_PPSIS_NIR = 'FETCH_GLOBAL_PPSIS_NIR';
export const FETCH_GLOBAL_PPSIS_NIR_DONE = 'FETCH_GLOBAL_PPSIS_NIR_DONE';
export const FETCH_GLOBAL_PPSIS_NIR_FAIL = 'FETCH_GLOBAL_PPSIS_NIR_FAIL';

export const HAS_RECALLED_PPSI_ERROR = 'HAS_RECALLED_PPSI_ERROR';

export const FETCH_RECALLED_ERROR_ONE = 'FETCH_RECALLED_ERROR_ONE';
export const FETCH_RECALLED_ERROR_ONE_DONE = 'FETCH_RECALLED_ERROR_ONE_DONE';
export const FETCH_RECALLED_ERROR_ONE_FAIL = 'FETCH_RECALLED_ERROR_ONE_FAIL';
// Transform local NIR market dish to Global PPSI
export const CREATE_PPSI_FROM_GLOBAL_NIR = 'CREATE_PPSI_FROM_GLOBAL_NIR';

// Discard draft PPSI for NIR markets
export const DISCARD_DRAFT_PPSI_NIR = 'DISCARD_DRAFT_PPSI_NIR';

// Delete PPSI for NIR markets
export const DELETE_PPSI_NIR = 'DELETE_PPSI_NIR';

// Approve PPSI for NIR Markets
export const APPROVE_PPSI_NIR = 'APPROVE_PPSI_NIR';

// Fetch global PPi IFS Market for local market
export const FETCH_GLOBAL_PPI_IFS = 'FETCH_GLOBAL_PPI_IFS';
export const FETCH_GLOBAL_PPI_IFS_DONE = 'FETCH_GLOBAL_PPI_IFS_DONE';
export const FETCH_GLOBAL_PPI_IFS_FAIL = 'FETCH_GLOBAL_PPI_IFS_FAIL';
export const SET_PPSI_ID = 'SET_PPSI_ID';
export const SHOW_POP_UP = 'SHOW_POP_UP';

// Fetch Market Dish Logo
export const FETCH_MARKET_DISH_LOGO = 'FETCH_MARKET_DISH_LOGO';
export const FETCH_MARKET_DISH_LOGO_DONE = 'FETCH_MARKET_DISH_LOGO_DONE';
export const FETCH_MARKET_DISH_LOGO_FAIL = 'FETCH_MARKET_DISH_LOGO_FAIL';

// save avaiblity tab
export const SAVE_AVAILABILITY_TAB = 'SAVE_AVAILABILITY_TAB';
export const SAVE_AVAILABILITY_TAB_DONE = 'SAVE_AVAILABILITY_TAB_DONE';
export const SAVE_AVAILABILITY_TAB_FAIL = 'SAVE_AVAILABILITY_TAB_FAIL';

// isAvailblity save button
export const IS_ENABLE_AVAILABLITY = 'IS_ENABLE_AVAILABLITY';

export const FETCH_RA_PA_NIR = 'FETCH_RA_PA_NIR';
export const FETCH_RA_PA_NIR_DONE = 'FETCH_RA_PA_NIR_DONE';
export const FETCH_RA_PA_NIR_FAIL = 'FETCH_RA_PA_NIR_FAIL';

export const NAVIGATE_TO_REVIEW = 'NAVIGATE_TO_REVIEW';
export const NAVIGATE_TO_REVIEW_DONE = 'NAVIGATE_TO_REVIEW_DONE';
export const NAVIGATE_TO_REVIEW_FAIL = 'NAVIGATE_TO_REVIEW_FAIL';
export const UPDATES_GLOBAL_PPSIS = 'UPDATES_GLOBAL_PPSIS';
export const UPDATES_GLOBAL_PPSIS_DONE = 'UPDATES_GLOBAL_PPSIS_DONE';
export const UPDATES_GLOBAL_PPSIS_FAIL = 'UPDATES_GLOBAL_PPSIS_FAIL';

export const UPDATES_PPSIS = 'UPDATES_PPSIS';
export const UPDATES_PPSIS_DONE = 'UPDATES_PPSIS_DONE';
export const UPDATES_PPSIS_FAIL = 'UPDATES_PPSIS_FAIL';

export const FETCH_PUBLISHED_UNPUBLISHED_PPSIS =
  'FETCH_PUBLISHED_UNPUBLISHED_PPSIS';
export const FETCH_PUBLISHED_UNPUBLISHED_PPSIS_DONE =
  'FETCH_PUBLISHED_UNPUBLISHED_PPSIS_DONE';
export const FETCH_PUBLISHED_UNPUBLISHED_PPSIS_FAIL =
  'FETCH_PUBLISHED_UNPUBLISHED_PPSIS_FAIL';
